import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import './styles/Landlord.css';
import Swal from 'sweetalert2';
import { useLandlordGuard } from '../../utils/authGuard';

const Dashboard = () => {
  const { isAuthorized } = useLandlordGuard();
  const [stats, setStats] = useState({
    totalProperties: 0,
    activeListings: 0,
    pendingInquiries: 0,
    recentBookings: [],
    propertyTypes: {
      apartments: 0,
      full_houses: 0,
      rooms: 0,
      boarding_houses: 0
    }
  });
  const [isLoading, setIsLoading] = useState(true);
  const base_url = 'https://api.homehive.co.zw/api';

  useEffect(() => {
    if (isAuthorized) {
      fetchDashboardData();
    }
  }, [isAuthorized]);

  const fetchDashboardData = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${base_url}/landlord/reports`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      setStats(response.data);
      setIsLoading(false);
    } catch (error) {
      Swal.fire({
        title: 'Error',
        text: 'Failed to load dashboard data',
        icon: 'error',
        confirmButtonColor: '#1a237e'
      });
      setIsLoading(false);
    }
  };

  const StatCard = ({ icon, title, value, type }) => (
    <div className={`stat-card hover-effect ${type}`}>
      <div className={`stat-icon ${type}`}>
        <i className={icon}></i>
      </div>
      <div className="stat-info">
        <h3>{title}</h3>
        <p className="stat-number">{value}</p>
      </div>
    </div>
  );

  if (!isAuthorized) return null;

  if (isLoading) {
    return (
      <div className="pulse-loader-container">
        <div className="pulse-loader">
          <div className="pulse-bubble pulse-bubble-1 fast-pulse-bubble"></div>
          <div className="pulse-bubble pulse-bubble-2 fast-pulse-bubble"></div>
          <div className="pulse-bubble pulse-bubble-3 fast-pulse-bubble"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="dashboard-container">

      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-icon properties">
            <i className="fas fa-home"></i>
          </div>
          <div className="stat-info">
            <h3>Total Properties</h3>
            <p className="stat-number">{stats.total_properties || 0}</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon active">
            <i className="fas fa-check-circle"></i>
          </div>
          <div className="stat-info">
            <h3>Active Listings</h3>
            <p className="stat-number">{stats.active_listings || 0}</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon inquiries">
            <i className="fas fa-eye"></i>
          </div>
          <div className="stat-info">
            <h3>Viewing Inquiries</h3>
            <p className="stat-number">{stats.pending_inquiries || 0}</p>
          </div>
        </div>
      </div>

      <div className="overview-section">
        <div className="section-header">
          <h2 className="section-title">
            <i className="fas fa-clock"></i>
            Recent Viewing Inquiries
          </h2>
        </div>
        
        <div className="activity-list">
          {/* Add activity items here */}
        </div>
      </div>
    </div>
  );
};

export default Dashboard; 